<template>
  <jw-textarea
    v-qfeiTrim
    :placeholder="isQuoteField ? '-' : modulesItem?.placeholder || ''"
    v-model="modulesItem.fieldValue"
    :auto-size="{
      minRows: 2,
      maxRows: 5
    }"
    :max-length="confine.number10001"
    :disabled="isQuoteField || modulesItem.businessData == '0' || disabledAll"
    class="system-form-item-fields"
    :class="{
      'ly-form-item-fields-disabled': isQuoteField,
      'ly-form-item-disabled': isQuoteField
    }"
    @blur="handleChange"
  />
</template>

<script setup>
import { confine } from '@/utils/const.js';
import { ref, computed } from 'vue';

const emits = defineEmits(['cb']);

const props = defineProps({
  modules: {
    type: Object,
    default: () => {}
  },
  disabledAll: {
    type: Boolean,
    default: false
  }
});

const modulesItem = ref(props?.modules);
const isQuoteField = computed(() => {
  return modulesItem?.value?.setting?.fieldType == 21;
});
const handleChange = () => {
  emits('cb', modulesItem.value);
};
</script>

<style scoped lang="less">
@import './text-area.less';
</style>
